import { useContext, useEffect } from "react";
import { ToolContext } from "../../../../context/ToolContext";
import Joyride from "react-joyride";
import { CustomTourTooltip } from "../CustomTourToolTip";

export const OrderWalkthrough = ({ pathname, end, start}) => {

    const {personalization_state, product_state} = useContext(ToolContext)
    const {walkthrough} = personalization_state
    const {orderList} = product_state

    const startTour = () =>{
        walkthrough.set((prev) => ({...prev, order:true}))
    }

    const endTour = ()=>{
        walkthrough.set((prev) => ({...prev, order:false}))
    }

    useEffect(() => {
        start("home", "order", startTour)
        //eslint-disable-next-line
    }, []);

    // useEffect(() => {
    //     walkthrough.data.onboarding && 
    // }, [walkthrough.data.onboarding]);

    const steps =[
            {
                content: "This shows your selected branch",
                placement: "right",
                target: "#walkthrough-order-step-1",
                disableBeacon: true,
            },
            {
                content: "Tap here to view previous transactions",
                placement: "right",
                target: "#walkthrough-order-step-2",
                disableBeacon: true
            },
            {
                content: "Tap the item or the plus icon to add quantity. You can also type the quantity inside the box",
                placement: "top",
                target: "#walkthrough-order-step-0",
                disableBeacon: true,
                disableOverlayClose: true,
                spotlightClicks: true,
            },
            {
                content: "Review transaction before tapping Checkout",
                placement: "right",
                target: "#walkthrough-order-step-4",
                disableBeacon: true
            },
        ]
        
    const CustomTooltip = ({ step, primaryProps, skipProps, backProps, tooltipProps, size, index}) => (
        <CustomTourTooltip end={end} featureName="home" p_name="order" step={step} primaryProps={primaryProps} skipProps={skipProps} backProps={backProps} tooltipProps={tooltipProps} size={size} index={index} setter={endTour} controls={index !== 2 ? true : (index === 2 &&  orderList.data.length > 0) ? true : false}/>
    ); 

    return(
        <Joyride
            disableOverlayClose={true} 
            run={walkthrough.data.order && window.location.pathname === pathname && !walkthrough.data.onboarding}
            steps={steps}
            hideCloseButton
            showSkipButton={false}
            showProgress
            tooltipComponent={CustomTooltip}
            callback={({ status}) => {
                if (status === 'finished') {
                    endTour()
                    end("home", "order")
                }
            }
            }
            spotlightClicks={true}
            styles={{
                spotlight:{
                    borderRadius: "11px"
                }
            }}
        />
    )
}
